import AxL from './axl';
import { ShapePoint } from './ShapePoint';
import { hexToHsl } from './utils';
import { v4 as uuidv4 } from 'uuid';

const PATH = '/paint-with-music/backend/api/';
const SHARE_MESSAGE =
  'Turn your paint brush into musical instruments with Google Arts & Culture';

class Sharing {
  constructor(axl, shapes, canvas, translator, buttons, limit = 90) {
    this.axl = axl;
    this.translator = translator;
    this.buttons = buttons;
    this.canvas = canvas;
    this.limit = limit;
    this.shapes = shapes;
    this.atmosphere = '';
    this.container = document.getElementById('sharing');
    this.shareButton = document.getElementById('sharebtn');
    this.loaderSvg = document.getElementById('sharing-loader');
    this.shareButton.addEventListener('click', (e) => {
      if (this.axl) {
        this.axl.sendMessage(AxL.ChildToHost.TRACK, {
          action: 'share',
        });
      }
      if (!this.shapes.history.length || !this.atmosphere.length) {
        this.shareDefaultUrl();
      } else {
        const id = uuidv4();
        this.shareCreation(id);
        this.save(id);
      }
    });
  }

  setShapesFromData(data, loopDuration) {
    this.sendEvent('clear');
    for (const shape of data.shapes) {
      const isStamp = 'p' in shape ? false : true;
      const halfHeight = this.canvas.height * 0.5;
      const instrumentData = this.buttons.getInstrumentProperties(shape.i);
      const color = instrumentData.color;
      const hsl = hexToHsl(color);
      const hslColor = { h: hsl[0], s: hsl[1], l: hsl[2] };
      const point = new ShapePoint({
        x: shape.x,
        y: shape.y,
        screenY: (shape.y + halfHeight) / this.canvas.height,
        isStamp: isStamp,
        time: shape.t,
        loopTime: shape.t,
        color: hslColor,
        hexColor: color,
        instrument: shape.i,
      });
      if (isStamp) {
        this.shapes.addStamp(point, hslColor);
      } else {
        const strokeIndex = this.shapes.strokes.length;
        const pointsCount = shape.p.length;
        for (let index = 0; index < pointsCount; index++) {
          const p = shape.p[index];
          this.shapes.currentStrokeIndex = strokeIndex;
          this.shapes.addPoint(
            new ShapePoint({
              x: p.x,
              y: p.y,
              screenY: (p.y + halfHeight) / this.canvas.height,
              isStamp: false,
              hairs: [],
              radius: p.r,
              time: p.t,
              loopTime: p.t,
              color: hslColor,
              hexColor: color,
              instrument: shape.i,
            })
          );
        }
      }
    }
  }

  changeAtmosphere(atmosphereId) {
    this.atmosphere = atmosphereId;
  }

  startLoading() {
    this.container.classList.add('shown');
    this.loaderSvg.classList.add('circular');
  }

  stopLoading() {
    this.container.classList.remove('shown');
    this.loaderSvg.classList.remove('circular');
  }

  get(id) {
    this.startLoading();
    return fetch(`${PATH}${id}`, {
      method: 'get',
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        this.stopLoading();
        return data;
      })
      .catch((error) => {
        this.stopLoading();
        return { error: error };
      });
  }

  shareDefaultUrl() {
    //this.stopLoading();
    if (this.axl) {
      this.axl.sendMessage(
        AxL.ChildToHost.SET_URL_PARAMS,
        this.atmosphere.length ? { atmosphere: this.atmosphere } : undefined
      );
      this.axl.sendMessage(AxL.ChildToHost.SHARE, {
        title: this.translator.dictionary.share_msg || SHARE_MESSAGE,
      });
    }
  }

  getImageUrl(data) {
    return `${PATH}image/${data.image.data}`;
  }

  save(id) {
    this.sendEvent('pause');

    if (!this.shapes.history.length || !this.atmosphere.length) {
      this.shareDefaultUrl();
      return;
    }

    this.sendEvent('share');
    this.startLoading();

    const shapes = [];
    let image = {
      width: this.canvas.width,
      height: this.canvas.height,
      data: this.canvas.toDataURL('image/png', 0.7),
    };
    let shapeIndex = 0;
    for (const shape of this.shapes.history) {
      if (shape.isStroke) {
        shapes.push({
          i: shape.instrument,
          p: shape.points.map((p) => {
            return {
              x: p.x,
              y: p.y,
              r: p.radius,
              t: p.loopTime,
            };
          }),
        });
      } else {
        shapes.push({
          i: shape.instrument,
          x: shape.x,
          y: shape.y,
          t: shape.loopTime,
        });
      }
      shapeIndex++;
      if (shapeIndex > this.limit) {
        break;
      }
    }

    const data = {
      atmosphere: this.atmosphere,
      shapes: shapes,
      image: image,
    };

    const url = `${PATH}create/${id}`;

    fetch(url, {
      method: 'POST',
      body: JSON.stringify(data),
      cache: 'no-cache',
      headers: new Headers({
        'content-type': 'application/json',
      }),
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        this.stopLoading();
        /*
                if ('id' in data) {
                    this.shareCreation(data.id);
                } else {
                    this.shareDefaultUrl();
                }*/
      })
      .catch((error) => {
        this.stopLoading();
        //this.shareDefaultUrl();
      });
  }

  shareCreation(id) {
    //this.stopLoading();
    if (this.axl) {
      this.axl.sendMessage(AxL.ChildToHost.SET_URL_PARAMS, { id: id });
      this.axl.sendMessage(AxL.ChildToHost.SHARE, { title: SHARE_MESSAGE });
    } else {
      console.log('============>> share ID : ', id);
    }
  }

  sendEvent(eventName) {
    const event = document.createEvent('Event');
    event.initEvent(eventName, true, true);
    document.dispatchEvent(event);
  }
}

export { Sharing };
